// --- Core ---
import {FieldRenderProps} from "react-final-form";
// --- Material UI ---
import {DateTimePicker, DateTimePickerProps} from "@mui/x-date-pickers";
// --- SaniQ ---
import {TextField} from "helpers/Forms";

interface DateTimeFieldProps extends FieldRenderProps<Date>, DateTimePickerProps {
  required: boolean;
}

/**
 * A component for rendering a DateTimePicker field with customized props.
 */
export const DateTimeField = ({input, meta, required, slotProps = {}, ...custom}: DateTimeFieldProps) => (
  <DateTimePicker
    // @ts-expect-error TextField typing is not done yet
    slotProps={{...slotProps, textField: {...slotProps.textField, meta, required, onBlur: input.onBlur}}}
    slots={{textField: TextField}}
    enableAccessibleFieldDOMStructure={false}
    {...input}
    value={input.value || null}
    InputLabelProps={{shrink: !!input.value}}
    {...custom}
  />
);
